import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import moment from 'moment';

import {
  Container,
  PageTitleContainer,
  PageTitle,
  Content,
  OrderIcon,
  ContainerItems,
  HeaderContainer,
  HeaderMobileContainer,
  IconLoading,
  StatusIcon,
  PeriodSize,
  FilterButton,
  Close,
  ContainerFilter,
  ContainerNoItems
} from './styles';

import filtericon from '~/assets/images/filter.svg';
import ModalDashboard from '~/components/pages/Dashboard/Modal';
import ModalFilter from '~/components/pages/Dashboard/ModalFilter';
import ItemList from '~/components/pages/Dashboard/ItemList';
import { NextPage, NextPageContainer } from '~/pages/Bankslips/styles';
import api from '~/services/api';
import Loading from '~/components/layout/Loading';
import SideBar from '~/components/layout/Sidebar';
import Header from '~/components/layout/Header';
import OpenChatBot from '~/components/layout/Chatbot';
import HeaderMobile from '~/components/layout/HeaderOld';
import BackPage from '~/components/layout/BackPage';
import { verifyRoles } from '~/utils/functions/verifyRoles';
import { Types } from "~/pages/GasVoucherList";
import trocasgray from '~/assets/images/trocas_gray.png';

export default function Dashboard() {
  const [canistersInView, setCanistersInView] = useState([]);
  const [canisterChoosed, setCanisterChoosed] = useState(null);
  const [loadingPage, setLoadingPage] = useState(true);
  const [notNext, setNotNext] = useState(false);
  const [loadingNext, setLoadingNext] = useState(false);
  const [lengthBelow20, setLengthBelow20] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [page, setPage] = useState(1);
  const [beginDate, setBeginDate] = useState(moment().format('YYYY-MM-DD'));
  const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DD'));
  const [showModalFilter, setShowModalFilter] = useState(false);
  const [beginDateFilter, setBeginDateFilter] = useState('');
  const [endDateFilter, setEndDateFilter] = useState('');
  const [updateRequest, setUpdateRequest] = useState(false);
  const [filterType, setFilterType] = useState("");
  const [sealNumber, setSealNumber] = useState("");

  const roles = useSelector(state => state.rolesReducer.roles);
  const economicGroupReducer = useSelector(
    (state) => state.economicGroupReducer
  );

  function activeModal() {
    setShowModal(!showModal)
  }

  function getCanisters(page) {
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('access_token'),
    };
    const parameters = {
      method: 'GET',
      headers: header,
    };
    const storeId = localStorage.getItem('storeId');
    let url = `/residential/store/v1/stores/${storeId}/canisters?_offset=${page}&_limit=10`;
    if(beginDate !== moment().format('YYYY-MM-DD')) {
      url = url + `&start-date=${beginDate}`
    }
    if(endDate !== moment().format('YYYY-MM-DD')) {
      url = url + `&end-date=${endDate}`
    }
    if(filterType !== "" && filterType !== "Todos") {
      let filtered = ""
      if(filterType === 'Aprovados') {
        filtered = "APPROVED"
      }
      if(filterType === 'Reprovados') {
        filtered = "REPROVED"
      }
      if(filterType === 'Em análise') {
        filtered = "PENDING_ANALYSIS"
      }
      if(filterType === 'Em aprovação') {
        filtered = "PENDING_APPROVAL"
      }
      url = url + `&status=${filtered}`
    }
    if(sealNumber !== "") {
      url = url + `&seal-number=${sealNumber}`
    }
    api
      .get(url, parameters)
      .then(res => {
        if(page > 1) {
          setCanistersInView([...canistersInView, ...res.data.canisterSeals])
        } else {
          setCanistersInView(res.data.canisterSeals)
        }
        if(res.data._metadata.totalPages === 1) {
          setLengthBelow20(true)
        } else {
          setLengthBelow20(false)
        }
        if(res.data._metadata.currentPage === res.data._metadata.totalPages) {
          setNotNext(true)
        } else {
          setNotNext(false)
        }
        setLoadingNext(false)
        setLoadingPage(false)
      })
      .catch(err => {
        setLoadingNext(false)
        setLoadingPage(false)
        toast.error("Ocorreu algum erro, tente novamente")
      });
  };

  function loadNextPage() {
    setLoadingNext(true)
    setPage(page + 1)
    getCanisters(page + 1)
  };

  function activeModal() {
    setShowModalFilter(!showModalFilter);
  }

  function activebeginDate(beginDate) {
    setBeginDateFilter(beginDate);
  }

  function activeEndDate(endDate) {
    setEndDateFilter(endDate);
  }

  async function changeFilter(type) {
    await setShowModalFilter(false);
    switch (type) {
      case Types.DAYS_7:
        setBeginDate(moment().subtract(7, 'days').format('YYYY-MM-DD'));
        setEndDate(moment().format('YYYY-MM-DD'));
        break;
      case Types.DAYS_15:
        setBeginDate(moment().subtract(15, 'days').format('YYYY-MM-DD'));
        setEndDate(moment().format('YYYY-MM-DD'));
        break;
      case Types.DAYS_30:
        setBeginDate(moment().subtract(30, 'days').format('YYYY-MM-DD'));
        setEndDate(moment().format('YYYY-MM-DD'));
        break;
      case Types.DAYS_60:
        setBeginDate(moment().subtract(60, 'days').format('YYYY-MM-DD'));
        setEndDate(moment().format('YYYY-MM-DD'));
        break;
    }
    await setPage(1);
    await setBeginDateFilter('');
    await setEndDateFilter('');
    await setUpdateRequest(!updateRequest);
  }

  async function changeFilterDate() {
    await setShowModalFilter(false);
    await setPage(1);
    if ((beginDateFilter === '' || endDateFilter === '') &&
      filterType === "" &&
      sealNumber === ""
    ) {
      toast.error('É necessário digitar a data inicial e final, digitar o número do lacre ou status');
    } else {
      if((beginDateFilter === '' || endDateFilter === '') &&
      filterType !== "" || sealNumber !== "") {
        await setBeginDate(
          moment().format('YYYY-MM-DD'),
        );
        await setEndDate(
          moment().format('YYYY-MM-DD'),
        );
        await setUpdateRequest(!updateRequest);
      } else {
        if (moment(beginDateFilter, 'DD/MM/YYYY').format('YYYY-MM-DD') === 'Invalid date') {
          toast.error('Escreva uma data inicial válida para continuar');
          setBeginDateFilter("")
        } else if (moment(endDateFilter, 'DD/MM/YYYY').format('YYYY-MM-DD') ==='Invalid date') {
          toast.error('Escreva uma data final válida para continuar');
          setEndDateFilter("")
        } else if (moment(endDateFilter, 'DD/MM/YYYY') < moment(beginDateFilter, 'DD/MM/YYYY')) {
          toast.error('A data final deve ser maior ou igual a data inicial');
        } else if (moment() < moment(endDateFilter, 'DD/MM/YYYY')) {
          toast.error('Período inválido');
        } else {
          await setBeginDate(
            moment(beginDateFilter, 'DD/MM/YYYY').format('YYYY-MM-DD'),
          );
          await setEndDate(
            moment(endDateFilter, 'DD/MM/YYYY').format('YYYY-MM-DD'),
          );
          await setUpdateRequest(!updateRequest);
        }
      }
    }
  }

  useEffect(() => {
    setLoadingPage(true);
    getCanisters(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [economicGroupReducer.selectedStore, updateRequest]);

  return (
    <>
      {openModal ? (
          <ModalDashboard
            carnister={canisterChoosed}
            close={() => setOpenModal(!openModal)}
          />
        ) : (
          <SideBar menuSelected={'Minha Conta'}>
            {verifyRoles(roles, 'TROCAS') ? (
              <>
                <ModalFilter
                  activeModal={activeModal}
                  activebeginDate={activebeginDate}
                  activeEndDate={activeEndDate}
                  changeFilter={changeFilter}
                  changeFilterDate={changeFilterDate}
                  showModal={showModalFilter}
                  beginDateFilter={beginDateFilter}
                  endDateFilter={endDateFilter}
                  loadingPage={loadingPage}
                  setFilterType={setFilterType}
                  filterType={filterType}
                  setSealNumber={setSealNumber}
                />
                <HeaderContainer>
                  <Header />
                </HeaderContainer>
                <Container>
                  <HeaderMobileContainer>
                    <HeaderMobile />
                  </HeaderMobileContainer>
                  <Content>
                    <BackPage page="/minha-conta" />
                    <PageTitleContainer>
                      <OrderIcon src={trocasgray} alt="Ícone de caminhão" />
                      <PageTitle>Trocas</PageTitle>
                    </PageTitleContainer>
                    {loadingPage ? (
                      <Loading />
                    ) : (
                      <ContainerItems>
                        <ContainerFilter>
                          <StatusIcon src={filtericon} alt="Ícone de filtro" />
                          <PeriodSize>Período:</PeriodSize>
                          <FilterButton>
                            <span onClick={() => {
                              setBeginDateFilter("")
                              setEndDateFilter("")
                              setShowModalFilter(true)
                            }}>
                              {beginDate === 'Invalid date'
                                ? moment().format('DD/MM/YYYY')
                                : moment(beginDate, 'YYYY-MM-DD').format(
                                    'DD/MM/YYYY',
                                  )}{' '}
                              -{' '}
                              {endDate === 'Invalid date'
                                ? moment().format('DD/MM/YYYY')
                                : moment(endDate, 'YYYY-MM-DD').format('DD/MM/YYYY')}
                            </span>
                            <Close onClick={() => {
                              setBeginDate(moment().format('YYYY-MM-DD'));
                              setEndDate(moment().format('YYYY-MM-DD'));
                              setUpdateRequest(!updateRequest);
                            }}>x</Close>
                          </FilterButton>
                        </ContainerFilter>
                        {
                          canistersInView.length < 1 ? (
                            <ContainerNoItems>
                              <span>Nenhum item encontrado!</span>
                            </ContainerNoItems>
                          ) : (
                            <>
                              {canistersInView.map(element => (
                                <ItemList
                                  key={element.sealNumber}
                                  order={element}
                                  ordersInView={canistersInView}
                                  activeModal={activeModal}
                                  setOpenModal={setOpenModal}
                                  setCanisterChoosed={setCanisterChoosed}
                                />
                              ))}
                            </>
                          )
                        }
                        {lengthBelow20 ? null : (
                          <NextPageContainer content="center">
                            {notNext ? null : (
                              <NextPage onClick={() => loadNextPage()}>
                                {loadingNext ? (
                                  <IconLoading className="fa fa-spinner fa-pulse fa-3x fa-fw" />
                                ) : (
                                  'Carregar mais...'
                                )}
                              </NextPage>
                            )}
                          </NextPageContainer>
                        )}
                      </ContainerItems>
                    )}
                  </Content>
                </Container>
              </>
            ) : (
            <Redirect to="/portal" />
          )}
          <OpenChatBot />
        </SideBar>
      )}
    </>
  )
}
